import { useEffect } from "react";

const TawkToChat = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/6542284ff2439e1631ea9d44/1he56qts5"; // Replace with your Tawk.to property ID
    script.async = true;
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Cleanup when unmounting
    };
  }, []);

  return null; // No UI, just injects the script
};

export default TawkToChat;
